import { Router } from "@frui.ts/screens/dist";
import TradingPlacesViewModel from "./tradingPlacesViewModel";
import LocalizationService from "../../services/localizationService";
import TradingPlaceService from "../../services/tradingPlaceService";

export const KioskNavigationName = "kiosk";

@Router.registerRoute({ route: KioskNavigationName, name: "kiosk" })
export default class KioskViewModel extends TradingPlacesViewModel {
  constructor(public localizationService: LocalizationService, tradingPlacesService: TradingPlaceService) {
    super(localizationService, tradingPlacesService);
    this.navigationName = KioskNavigationName;
    this.mapButtonTitle = this.translateGeneral("showKioskMap");

    this.showMap = false;
    this.visibleRoads = {
      free: false,
      paid: false,
      year: this.roadMapYears[0],
    };
    this.visibleTradingPlaces = {
      kiosk: true,
      salesPoint: false,
    };
    this.mapButtonContainerClassName = "text-sm-left";
  }
  protected async onInitialize() {
    await this.tradingPlacesService.initialize();
    return super.onInitialize();
  }
}
